import { bool, func, oneOf } from "prop-types";
import { useTranslation } from "react-i18next";
import { Alert } from "@components";
import { useState } from "react";

export const DifferentValueAlert = ({
  moduleLevel,
  handleValueAlertClose,
  hasChildAutomation,
}) => {
  const { t } = useTranslation();
  
  const [ showAutomationAlert, setShowAutomationAlert ] = useState(false);
  
  const onAccept = () => {
    if(hasChildAutomation)
      setShowAutomationAlert(true);
    else
      handleValueAlertClose(true);
  }
  const onAcceptSplit = () => handleValueAlertClose(false);
  const onCancel = () => handleValueAlertClose();
  
  const onAcceptFull = () => {
    setShowAutomationAlert(false);
    handleValueAlertClose(true);
  }

  
  return (
    <>
      <Alert
        isOpen
        title={t(`views.editor.children_value_alert.title`, { level: t(`proposal_parts.module_levels.level_${moduleLevel}`) })}
        acceptText={t("views.editor.children_value_alert.reset")}
        intermediateText={t("views.editor.children_value_alert.split")}
        cancel={t("common.cancel")}
        onAccept={onAccept}
        onIntermediate={onAcceptSplit}
        onCancel={onCancel}
        width={600}
      />
      {
        showAutomationAlert &&
        <Alert
          isOpen
          title={t("views.editor.children_value_alert.automation_title")}
          acceptText={t("common.continue_full")}
          onAccept={onAcceptFull}
          onCancel={onCancel}
          width={600}
        >
          {t("views.editor.children_value_alert.automation")}
        </Alert>
      }
  </>
  )
}

DifferentValueAlert.propTypes = {
  moduleLevel: oneOf([0, 1, 2, 3]).isRequired,
  handleValueAlertClose: func.isRequired,
  hasChildAutomation: bool,
}